<template>
  <div class="scheme_details">
    <b-row
      class="content-header"
    >
      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ scheme.stringID }} - {{ scheme.name }}
            </h1>
            <p class="log_info">
              Created by {{ scheme.createdBy ? scheme.createdBy.name : '' }} on {{ dateFormatWithTime(scheme.createdAt) }} <br>Last updated on {{ dateFormatWithTime(scheme.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="3"
        cols="12"
      >
        <div class="user_block pr_stage_type">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Status</h6>
            <h5 :class="`text-${resolveStatusVariant(scheme.status)}`">
              {{ scheme.status }}
            </h5>
          </div>
          <div
            v-if="canViewThisAction('update', 'EntitlementScheme')"
            class="action_button"
          >
            <b-button
              v-b-modal.modal-update-status
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card
          header-tag="header"
          class="calllog-details"
        >
          <div class="d-flex justify-content-between align-items-center w-100 header_part">
            <h5 class="mb-0">
              Scheme Details
            </h5>

            <b-button
              v-if="canViewThisAction('update', 'EntitlementScheme')"
              variant="flat-primary"
              :to="{ name: 'products-schemes-edit', params: { id: $route.params.id } }"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Edit</span>
            </b-button>
          </div>
          <b-table-simple
            borderless
            responsive
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Scheme
                </b-th>
                <b-td class="mt-50">
                  {{ scheme.name }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Internal Remarks
                </b-th>
                <b-td class="mt-50">
                  <span class="mt-50">
                    {{ scheme.remarks }}
                  </span>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <hr class="dividerHR">
          <div
            v-for="(condition, key) in scheme.conditions"
            :key="key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230">
                    Condition #{{ key + 1 }}
                  </b-th>
                  <b-td class="mt-50">
                    {{ condition.condition }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Sales Submission Date
                  </b-th>
                  <b-td class="mt-50">
                    <span class="mt-50">
                      {{ formatCondition(condition) }}
                    </span>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Applicable Product Catalog Items
                  </b-th>
                  <b-td>
                    <b-badge
                      v-for="item in condition.inventoryItems"
                      :key="item._id"
                      variant="light-primary"
                      class="mr-50"
                    >
                      {{ item.name }}
                    </b-badge>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    Applicable Promotion(s)
                  </b-th>
                  <b-td>
                    <b-badge
                      v-for="item in condition.promotions"
                      :key="item._id"
                      variant="light-primary"
                      class="mr-50"
                    >
                      {{ item.name }}
                    </b-badge>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <hr
              v-if="key !== scheme.conditions.length - 1"
              class="dividerHR"
            >
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-card
      header-tag="header"
      class="calllog-details"
    >
      <div class="d-flex justify-content-between align-items-center w-100 header_part">
        <h5 class="align-middle mr-auto">
          Entitlement Item(s) to be Issued
        </h5>
        <b-button
          v-if="canViewThisAction('create', 'EntitlementScheme')"
          variant="flat-primary"
          :to="{ name: 'products-scheme-items-create', query: { scheme: $route.params.id } }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle">Add Entitlement Item</span>
        </b-button>
      </div>
      <b-tabs content-class="mt-1">
        <b-tab
          v-for="(item, type) in schemeItems"
          :key="type"
          :title="item.name"
        >
          <b-table-simple
            borderless
            small
          >
            <b-tbody>
              <b-tr>
                <b-th
                  width="200"
                >
                  Entitlement Item Type
                </b-th>
                <b-td>{{ resolveTypeValue(item.type) }}</b-td>
              </b-tr>

              <b-tr v-if="item.type == 2">
                <b-th>Funeral Service Package</b-th>
                <b-td>{{ resolveFuneralServicePackageValue(item.funeralServicePackage) }}</b-td>
              </b-tr>

              <b-tr>
                <b-th>Validity</b-th>
                <b-td v-if="item.lifeTime">
                  Lifetime
                </b-td>
                <b-td v-else>
                  {{ item.validityYear }} {{ item.validityType }}
                </b-td>
              </b-tr>

              <b-tr>
                <b-th>Terms & Conditions</b-th>
                <b-td>
                  <!-- eslint-disable -->
                  <div
                    class="rich-text-modify"
                    v-html="item.termsCondition"
                  />
                </b-td>
              </b-tr>

              <b-tr>
                <b-th>Paid Entitlement</b-th>
                <b-td>{{ item.paidEntitlement == 'yes' ? 'Yes' : 'No' }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <hr>

          <!-- Inventory Items -->
          <div v-if="item.inventoryOptions.length">
            <h5 class="align-middle mr-auto">
              Inventory Options
            </h5>
            <p>
              Customer to choose 1 from the following options on redemption:
            </p>

            <b-table-simple
              small
              responsive
              class="has_padding shadow-table"
            >
              <b-thead>
                <b-tr>
                  <b-th>Inventory item Options</b-th>
                  <b-th>Category</b-th>
                  <b-th>Brand</b-th>
                  <b-th>Created</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="(inv, index) in item.inventoryOptions"
                  :key="index"
                >
                  <b-td>
                    <div class="d-flex align-items-center">
                      <img
                        :src="inv.item.image || require('@/assets/images/placeholder/placeholder_image.png')"
                        alt="item image"
                        class="mr-1"
                        style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px; border: 1px solid #D2DCEA;"
                      >
                      <div>
                        <div class="item_name">{{ inv.item.name }}</div>
                        <p class="text-muted mb-0">{{ inv.item.sku }}</p>
                      </div>
                    </div>
                  </b-td>
                  <b-td>{{ inv.item && inv.item.category ? inv.item.category.name : '-' }}</b-td>
                  <b-td>{{ inv.item.brand }}</b-td>
                  <b-td>{{ dateFormatWithTime(inv.item.createdAt) }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
          <div
            class="d-flex align-items-center mt-2"
            :class="item.type == 1 ? 'justify-content-between' : 'justify-content-between'"
          >
            <!-- Left: Remove -->
            <b-button
              variant="outline-primary"
              @click="removeSchemeItem(item._id)"
            >
              <feather-icon icon="Trash2Icon" size="14" class="mr-50" />
              Remove Entitlement Item
            </b-button>

            <!-- Right: Duplicate + Edit -->
            <div>
              <b-button
                v-if="canViewThisAction('create', 'EntitlementScheme')"
                :to="{ name: 'products-scheme-items-create', query: { scheme: $route.params.id, duplicateId: item._id } }"
                variant="outline-primary"
                class="mr-1"
              >
                <feather-icon icon="CopyIcon" size="14" class="mr-50" />
                Duplicate
              </b-button>

              <b-button
                v-if="canViewThisAction('create', 'EntitlementScheme')"
                :to="{ name: 'products-scheme-items-edit', params: { id: item._id } }"
                variant="primary"
              >
                <feather-icon icon="EditIcon" size="14" class="mr-50" />
                Edit {{ item.name }}
              </b-button>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-card
      header-tag="header"
    >
      <div class="d-flex justify-content-between align-items-center w-100 header_part">
        <h5 class="align-middle mr-auto">
          Issued to Customers
        </h5>
      </div>
      <RelatedEntitlements
        :entitlements="entitlements"
        @emitCountEntitlement="getEntitlementScheme"
      />
    </b-card>

    <b-card
      class="mb-3 mt-3 p-2"
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left pb-2"
          cols="12"
          md="12"
        >
          <h4>
            <feather-icon
              icon="ListIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle">Activity Logs</span>
          </h4>
        </b-col>
      </b-row>
      <app-timeline>
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in schemeDetailActivityLogs"
          :key="key"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6>{{ opt.title }}</h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
          </div>
          <b-button
            v-if="opt.activityDetails && opt.activityDetails.length"
            v-b-toggle="'report-list-with-icon-' + key"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
          >
            Details
            <feather-icon
              icon="ChevronUpIcon"
              class="ml-50 when-open"
              size="16"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50 when-closed"
              size="16"
            />
          </b-button>
          <b-collapse
            v-if="opt.activityDetails && opt.activityDetails.length"
            :id="'report-list-with-icon-' + key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr
                  v-for="(activityDetail, activitykey) in opt.activityDetails"
                  :key="activitykey"
                >
                  <b-th style="width: 300px; max-width: 300px;">
                    {{ activityDetail.title }}
                  </b-th>
                  <b-td>{{ activityDetail.oldValue }}</b-td>
                  <b-td>{{ activityDetail.newValue }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </app-timeline-item>
      </app-timeline>
    </b-card>

    <b-modal
      id="modal-update-status"
      ref="update-status-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Status"
      @ok="submitForm"
    >
      <b-form @submit.prevent="submitForm">
        <validation-observer
          ref="schemeStatusEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-scheme-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-scheme-status"
                v-model="status"
                label="title"
                :options="statusDataOptions"
                :reduce="title => title.code"
                :clearable="false"
                @input="statusValidation == true ? statusValidation = false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="statusValidation"
                class="text-danger"
              >
                {{ statusError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BButton, BCol, BTableSimple, BTbody, BTr, BTh, BThead, BTd, VBTooltip, BBadge, BForm, BFormGroup, BTabs, BTab,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import 'array.prototype.move'
import moment from 'moment'
import store from '@/store/index'
import vSelect from 'vue-select'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import RelatedEntitlements from './RelatedEntitlements.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BButton,
    BCol,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BTd,
    BForm,
    BFormGroup,
    BTabs,
    BTab,
    BThead,

    BBadge,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    RelatedEntitlements,
    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      topSpacing: 135,
      canViewThisAction,
      scheme: {},
      schemeItems: [],
      schemeDetailActivityLogs: [],
      catArticles: [],
      status: 'active',
      statusValidation: false,
      statusError: 'Valid status is required',
      entitlements: [],
      statusDataOptions: [
        { title: 'Active', code: 'active' },
        { title: 'Inactive', code: 'inactive' },
        { title: 'Expired', code: 'expired' },
      ],
      required,
    }
  },
  created() {
    this.getEntitlementScheme()
    this.getEntitlementSchemeItem()
  },

  methods: {
    removeSchemeItem(id) {
      this.$swal({
        title: 'Remove this entitlement item from scheme?',
        html: 'Are you sure you want to remove this entitlement item from the scheme? This action cannot be undone, and only impacts future issuance, and not existing issued entitlements.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/delete_red.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Yes, Remove this item',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            await this.$http.delete(`reservation/entitlement-scheme-items/${id}/delete`)

            this.$swal({
              title: 'Item has been removed',
              html: '',
              // eslint-disable-next-line global-require
              imageUrl: require('@/assets/images/icons/success.png'),
              imageWidth: 80,
              imageHeight: 80,
              imageAlt: 'Custom Icon',
              showCancelButton: false,
              showConfirmButton: false,
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            this.getEntitlementSchemeItem()
          }
        })
    },
    resolveStatusVariant(status) {
      if (status === 'active') return 'success'
      if (status === 'inactive') return 'danger'
      if (status === 'expired') return 'secondary'
      return 'primary'
    },
    resolveTypeValue(type) {
      if (type === 1) return 'Inventory-managed item'
      if (type === 2) return 'Funeral Service Package'
      if (type === 3) return 'Non-inventory-managed item'
      return ''
    },
    resolveFuneralServicePackageValue(type) {
      if (type === 1) return 'NV Longevity'
      return ''
    },
    formatCondition(condition) {
      const { startDate, endDate } = condition

      const start = startDate
        ? moment(startDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
        : null

      const end = endDate
        ? moment(endDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
        : null

      if (start && end) return `${start} to ${end}`
      if (start) return `from ${start}`
      if (end) return `until ${end}`

      return '-'
    },
    resolveArticleStatusVariant(status) {
      if (status === 'active') return 'success'
      if (status === 'inactive') return 'secondary'
      return 'primary'
    },

    getEntitlementScheme() {
      this.$http.get(`reservation/entitlement-schemes/${this.$route.params.id}/show`)
        .then(response => {
          this.scheme = response.data.scheme || {}
          this.entitlements = response.data.entitlements
          store.commit('breadcrumb/REMOVE_BREADCRUMB')
          const newMeta = {
            active: true,
            text: `${this.scheme.name}`,
          }
          store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
          this.schemeDetailActivityLogs = this.scheme.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    getEntitlementSchemeItem() {
      this.$http.get('reservation/entitlement-scheme-items', {
        params: {
          entitlementScheme: this.$route.params.id,
        },
      })
        .then(response => {
          this.schemeItems = response.data.schemeItems || []
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    submitForm() {
      this.$refs.areaStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.status)

          this.$http.patch(`reservation/entitlement-schemes/${this.$route.params.id}/status/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              this.scheme.status = response.data.data.status || 'active'
              this.status = this.scheme.status

              this.$swal({
                title: 'Status Updated!',
                html: 'The status for this area has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.display-content {
  display: contents;
}

.custom-th-width {
  .table th {
      padding: 0.72rem 2rem 0.72rem 0.72rem;
  }
}
</style>
